import React from 'react';
import { Button, ButtonProps, Tooltip, Box } from '@chakra-ui/react';
import { UsageResource } from '../utils/planUsage';
import { usePlanUsage } from '../hooks/usePlanUsage';

interface LimitRestrictedButtonProps extends ButtonProps {
  resource: UsageResource;
}

const LimitRestrictedButton: React.FC<LimitRestrictedButtonProps> = ({
  resource,
  isDisabled,
  ...props
}) => {
  const { isAtLimit, getResourceLimitMessage, isLoading } = usePlanUsage();
  const atLimit = !isLoading && isAtLimit(resource);
  const tooltip = atLimit ? getResourceLimitMessage(resource) : undefined;

  const button = <Button {...props} isDisabled={isDisabled || atLimit} />;

  if (!tooltip) {
    return button;
  }

  return (
    <Tooltip label={tooltip} hasArrow placement="top">
      <Box as="span" display="inline-block" lineHeight="normal">
        {button}
      </Box>
    </Tooltip>
  );
};

export default LimitRestrictedButton;
